<div class="billing-header">
  <div class="custom-icon component">component icon</div>
  <h4>Billing Components ({{ components?.length || 0 }})</h4>
</div>

@if (components.length > 0) {
  <div class="billing-services-list">
    <ul>
      @for (component of components; track component.Id) {
        <li>
          {{ component.Display_Name__c }}
          <span>{{ component.MRR__c | currency }}</span>
        </li>
      }
    </ul>
  </div>
}